import React from 'react';
import profileImage from "/images/KimBV.png";

const About: React.FC = () => {
  return (
    <section id="about" className="bg-neutral-900 py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <p className="text-red-500 font-mono text-xs uppercase tracking-widest text-center mb-3">Who I am</p>
        <h2 className="text-4xl font-bold text-white text-center mb-16">About Me</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1 space-y-5">
            <p className="text-gray-300 leading-relaxed">
              I'm Kim Vallén, a passionate audio enthusiast and a skilled .NET developer.
              My journey in sound started in <span className="text-red-400 font-semibold">2004</span> while
              code entered my life in <span className="text-red-400 font-semibold">2016</span>, and I've
              become a master of both sound and code.
            </p>
            <p className="text-gray-400 leading-relaxed">
              While I love embracing new tech, I prioritize clean, maintainable code.
              I believe in crafting elegant solutions that stand the test of time.
              Let's create digital wonders together.
            </p>
            <div className="flex gap-6 pt-2">
              <div className="border-l-2 border-red-600 pl-4">
                <p className="text-white font-bold text-2xl">20+</p>
                <p className="text-gray-500 text-sm font-mono">years in audio</p>
              </div>
              <div className="border-l-2 border-red-600 pl-4">
                <p className="text-white font-bold text-2xl">9+</p>
                <p className="text-gray-500 text-sm font-mono">years in dev</p>
              </div>
            </div>
          </div>

          <div className="order-1 md:order-2 flex justify-center">
            <div className="relative">
              <div className="absolute -inset-1 bg-red-600/20 blur-lg rounded-sm" />
              <img
                className="relative w-64 h-64 md:w-80 md:h-80 object-cover shadow-2xl rounded-sm"
                src={profileImage}
                alt="Kim Vallén"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
